var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportSummaryRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F2994A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6099_8888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.408 28.3655H27.1393V31.6343H30.408V28.3655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6699 46.0714V21.1471H34.3581V46.0714H13.9283V40.6235H17.1971V13.9286H34.3581V18.8317H41.849V43.8923H45.254V46.2076H39.6699V46.0714ZM16.1075 43.8923H32.179V16.1078H19.3763V42.8027H16.1075V43.8923Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6099_8888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.3257,
    height: 32.1429,
    fill: "white",
    transform: "translate(13.9283 13.9286)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSummaryRoom);
export default __webpack_public_path__ + "static/media/report-summary-room.56298fac21d8be7052dc8f5b319e8d69.svg";
export { ForwardRef as ReactComponent };